export const recipesActionTypes = {
  SET_RECIPES: 'SET_RECIPES',
  CLEAR_RECIPES: 'CLEAR_RECIPES',
  ADD_INGREDIENT: 'ADD_INGREDIENT',
  REMOVE_INGREDIENT: 'REMOVE_INGREDIENT',
  CLEAR_INGREDIENTS: 'CLEAR_INGREDIENTS',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_LOADING: 'SET_LOADING',
  SET_SUGGESTIONS: 'SET_SUGGESTIONS',
  SET_CURRENT_RECIPE: 'SET_CURRENT_RECIPE',
}
